import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import BaseViewService from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-service';
import { IPcLeftThumbnailListServiceLogic } from '@src/slide/application/service/pc-left-thumbnail-list/core/pc-left-thumbnail-list-service.interface';

export const SLIDE_WIDTH = 152;
export const SECTION_WIDTH = 180;

export interface IPcLeftThumbnailListProps {
    shouldUpdate: boolean;
    style: any;
    slideListService: IPcLeftThumbnailListService
}

export interface IPcLeftThumbnailListState {
    isPressed: boolean;
    slideModelList: Array<ISlideModel>;
    masterModelList: Array<IMasterModel>;
    currentSlideType: string;
    slideClearanceIndex: number;
    slideHeight: number;
    slideWidth: number;
    sectionWidth: number;
    originalDragSlide: any;
    currentDragIndex: number;
    slideInnerHeight: number;
    historyTipsSlide: number;
    lockInfo: any;
    outside: boolean;
    originalDragIndex: number;
    shouldUpdate: boolean;
    isFirstSlideShow: boolean;
    isShowingHistory: boolean;
    currentSlideIndex: number;
    editType: string;
    viewType: string;
    isDraggingSection: boolean;
    sectionList: ISectionModel[];
    isSectionDrag: boolean;
    sectionFoldedState: boolean[];
}

export type IPcLeftThumbnailListService = BaseViewService<IPcLeftThumbnailListProps> & IPcLeftThumbnailListServiceLogic;
